import React from 'react';
import LiquidLiquidSolidForm from '../../components/forms/liquidLiquidSolidForm';

const LiquidLiquidSolid: React.SFC<any> = (props) => (
  <LiquidLiquidSolidForm {...props} />
);

export default LiquidLiquidSolid;
